import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQSection = ({ title, items }) => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.paper' }}>
      <Container>
        <Typography 
          variant="h2" 
          component="h2" 
          sx={{ 
            mb: 4, 
            textAlign: 'center',
            color: 'text.secondary'
          }}
        >
          {title}
        </Typography>
        
        <Box sx={{ maxWidth: 800, mx: 'auto' }}>
          {items.map((item, index) => (
            <Accordion 
              key={index} 
              sx={{ 
                mb: 2, 
                '&:before': { display: 'none' }, 
                boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.2)'
              }}
            >
              <AccordionSummary 
                expandIcon={<ExpandMoreIcon />}
                sx={{ bgcolor: 'background.default' }}
              >
                <Typography variant="h6" sx={{ color: 'grey.300' }}>
                  {item.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{bgcolor: 'background.default'}} >
                <Typography 
                  variant="body2" 
                  component="div" 
                  sx={{ 
                    color: 'text.secondary',
                    '& p': { 
                      mb: 1.5 
                    },
                    '& p:last-child': { 
                      mb: 0 
                    }
                  }}
                >
                  {item.answer.map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                  ))}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FAQSection;